import React from "react"
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.css';

function Header() {
    return (<>
        <header>
            <div className="container-fluid">
                <div className="row">
                    {localStorage.getItem("PMSSource") !== "" && localStorage.getItem("PMSSource") === "CRX" ?
                        <div className="tds-computer-rxlogo">
                            <img src={process.env.PUBLIC_URL + "/CRX_web_logo_600x150.png"} alt="RX Logo" />
                        </div>
                        :
                        <div className="tds-rx30-logo">
                            <img src={process.env.PUBLIC_URL + "/RX30_logo_rev_300x135.png"} alt="RX Logo" />
                        </div>
                    }

                </div>
            </div>
        </header>
    </>
    )


}

export default Header;